import type { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

/*
 * shadcn/ui Badge (new-york). Upstream uses class-variance-authority; a
 * variant map does the same job without the dependency.
 */

const BADGE_VARIANTS = {
  default: 'border-transparent bg-neutral-100 text-neutral-600',
  success: 'border-green-500 bg-green-100 text-green-800',
  info: 'border-sky-600 bg-sky-50 text-sky-900',
  outline: 'border-neutral-300 text-neutral-700',
} as const;

export type BadgeVariant = keyof typeof BADGE_VARIANTS;

export function Badge({
  className,
  variant = 'default',
  ...props
}: ComponentProps<'span'> & { variant?: BadgeVariant }) {
  return (
    <span
      data-slot="badge"
      data-variant={variant}
      className={twMerge(
        'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap',
        BADGE_VARIANTS[variant] ?? BADGE_VARIANTS.default,
        className
      )}
      {...props}
    />
  );
}
